import axios from 'axios';
import Helper from './helper.service';
import * as _ from 'lodash';

export const API_URL = process.env.REACT_APP_API_URL + "api/public/";
export const IMG_URL = process.env.REACT_APP_IMG_URL + "uploads/artbanne/";

export const getSubmissionData = async (id, t) => {
    try {
        const response = await axios.get(API_URL + 'submission/getSubmission/' + id);
        console.log(response);
        Helper.handleApiResponse(response, t('responses.dataFetched'), t('responses.dataFetchedError'));

        return response;

    } catch (error) {
        Helper.toast(t('errors.submissionError'), 'error');
        return;
    }
};

export const submitFormData = async (id = null, customer, billing, services = [], subdomain = null, t) => {
    console.log("Customer Data before sending:", customer);
    console.log("Billing Data before sending:", billing);

    const formDataToSend = new FormData();

    if (id) {
        formDataToSend.append('id', id);
    }

    // Infos client
    formDataToSend.append('userId', customer.userId || '');
    formDataToSend.append('email', customer.email || '');
    formDataToSend.append('lastName', customer.lastname || '');
    formDataToSend.append('firstName', customer.firstname || '');
    formDataToSend.append('phone', customer.phone || '');

    // Infos de facturation
    formDataToSend.append('address', billing.address || '');
    formDataToSend.append('address2', billing.address2 || '');
    formDataToSend.append('city', billing.city || '');
    formDataToSend.append('postalCode', billing.postalCode || '');
    formDataToSend.append('country', billing.country || '');
    formDataToSend.append('VATNumber', billing.VATNumber || '');
    formDataToSend.append('companyName', billing.companyName || '');

    // Services
    formDataToSend.append('services', JSON.stringify(services || []));

    // Sous-domaine : always send a string.
    // On the main domain there is no tenant subdomain, so keep the historical
    // value "services" instead of serializing the context object.
    formDataToSend.append('subdomain', subdomain || 'services');

    try {
        const response = await axios.post(API_URL + 'submission/submit', formDataToSend, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        return response;
    } catch (error) {
        console.error("Submit error:", error);
        alert(t('errors.submissionError'));
    }
};

export const submitFilesOnly = async (id, formData, t) => {
    const formDataToSend = new FormData();

    if (!id) throw new Error("Missing submission ID");
    formDataToSend.append('id', id);

    // Attach all File objects (docs + field files)
    Object.entries(formData).forEach(([key, value]) => {
        if (value instanceof File) {
            formDataToSend.append(key, value);
        }
    });

    // Include plain (non-file) field values
    const plainFields = formData.fieldsPayload || formData.fields;
    if (plainFields && typeof plainFields === 'object') {
        formDataToSend.append('fieldsPayload', JSON.stringify(plainFields));
    }

    try {
        const response = await axios.post(API_URL + 'submission/upload-files', formDataToSend, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response;
    } catch (error) {
        console.error("File upload error:", error);
        alert(t('errors.submissionError'));
        throw error;
    }
};

export const validateFreeService = async (submissionId, t) => {
    try {
        if (!submissionId) {
            throw new Error("Missing submission ID");
        }

        const response = await axios.post(API_URL + 'systempay/validateFreeService', {
            submissionId
        });

        return response;

    } catch (error) {
        console.error("Validate free service error:", error);

        if (t) {
            Helper.toast(
                t('errors.submissionError') || "Erreur lors de la validation de la prestation gratuite",
                'error'
            );
        } else {
            Helper.toast(
                "Erreur lors de la validation de la prestation gratuite",
                'error'
            );
        }

        throw error;
    }
};

export const submitAddressFormData = async (id = null, formData, t) => {
    const formDataToSend = new FormData();
    if (id) {
        formDataToSend.append('id', id);
    }

    formDataToSend.append('address', formData.address);
    formDataToSend.append('zipCode', formData.zipCode);
    formDataToSend.append('town', formData.town);
    formDataToSend.append('dateOfBirth', formData.dateOfBirth);
    formDataToSend.append('placeOfBirth', formData.placeOfBirth);

    try {
        const response = await axios.post(API_URL + 'submission/submitAddress', formDataToSend, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // Handle success
        console.log(response);

        // Helper.handleApiResponse(response, t('success.dataFetched'), t('success.dataFetchedError'));

        return response;
    } catch (error) {
        // Handle error
        alert(t('errors.submissionError'));
    }
};

export const getSubdomain = async (subdomain, userId = null) => {
    try {
        const query = userId ? `?userId=${encodeURIComponent(userId)}` : '';

        const response = await axios.get(
            API_URL + `subdomains/getSubdomain/${encodeURIComponent(subdomain)}${query}`
        );

        return response.data.data;
    } catch (error) {
        Helper.toast("Erreur lors de la récupération du sous-domaine", 'error');
        return;
    }
};

export const getServices = async () => {
    try {
        const response = await axios.get(API_URL + 'services');
        return response.data;

    } catch (error) {
        Helper.toast("Erreur lors de la récupération des prestations", 'error');
        console.log(error);
        return error;
    }
};

export const getDocuments = async () => {
    try {
        const response = await axios.get(API_URL + 'documents');
        return _.get(response, 'data.data', []);

    } catch (error) {
        Helper.toast("Erreur lors de la récupération des documents", 'error');
        console.log(error);
        return error;
    }
};

export const getFields = async () => {
    try {
        const response = await axios.get(API_URL + 'fields');
        return _.get(response, 'data', []);

    } catch (error) {
        Helper.toast("Erreur lors de la récupération des champs", 'error');
        console.log(error);
        return error;
    }
};

export const getPaymentLinkById = async (id, t) => {
    try {
        const response = await axios.get(API_URL + 'payment-links/' + id);
        return _.get(response, 'data.data', null);

    } catch (error) {
        console.error("PaymentLink fetch error:", error);
        return null;
    }
};